import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cleanSearchingUsersPaginated, userClean } from "../../app/actions/userActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsUsers = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    if (icon === "new") {
      trackEvent({ component: "NewUsers", event: "NewUsers-Clicked" });
    } else if (icon === "list") {
      trackEvent({ component: "ListUsers", event: "ListUsers-Clicked" });
       dispatch(cleanSearchingUsersPaginated());
    }

    dispatch(userClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}

      {page === "listUser" && (
        <Link data-tip data-for="newUserTip" to="/admin-user/new-user" className="p-2 bd-highlight" onClick={() => handleActiveIcon("new")}>
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newUser" && (
        <Link data-tip data-for="listUserTip" to="/admin-user/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("list")}>
          <i className={`fa fa-table fa-2x  ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editUser" && (
        <div className="navbar-module-actions">
          <Link data-tip data-for="listUserTip" to="/admin-user/" className="p-2 bd-highlight" onClick={() => handleActiveIcon("list")}>
            <i className={`fa fa-table fa-2x  ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link data-tip data-for="newUserTip" to="/admin-user/new-user" className="p-2 bd-highlight" onClick={() => handleActiveIcon("new")}>
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newUserTip" place="left" effect="solid">
        {t("admin-user.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listUserTip" place="left" effect="solid">
        {t("admin-user.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsUsers;
